import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

interface ConfirmTaxFileProcessedByModalProps {
    visible: boolean;
    onHide: () => void;
    onConfirm: () => void;
    loading: boolean;
    employeeName: string;
}

const ConfirmTaxFileProcessedByModal = ({
    visible,
    onHide,
    onConfirm,
    loading,
    employeeName
}: ConfirmTaxFileProcessedByModalProps) => {
    return (
        <Dialog
            visible={visible}
            style={{ width: '550px' }}
            header="Confirm Tax File Processed By"
            className="mx-3 lg:mx-0"
            draggable={false}
            modal
            footer={
                <>
                    <Button
                        label="Cancel"
                        icon="pi pi-times"
                        className="p-button-secondary"
                        onClick={onHide}
                    />
                    <Button
                        label="Confirm"
                        icon="pi pi-check"
                        className="common-primary-button"
                        onClick={onConfirm}
                        loading={loading}
                    />
                </>
            }
            onHide={onHide}
        >
            <div className="">
                <div className="grid p-fluid formgrid">
                    <div className="field col-12">
                        <label style={{ fontSize: '16px' }}>
                            Confirm Tax File Processed By{' '}
                            <span style={{ fontWeight: '600' }}>
                                {employeeName}
                            </span>
                        </label>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default ConfirmTaxFileProcessedByModal;